export default __webpack_public_path__ + "static/media/company.2325eb93.svg";